import styles from "../CreatorsPage.module.scss";
import { CheckCircle, Link } from "./icons";
import { img } from "./images";
import MexicoMap from "./MexicoMap";

const Make = () => (
	<section id="make" aria-labelledby="make-h">
		<div className={styles.wrap}>
			<div className={styles.secHead}>
				<span className={styles.eyebrow}>What you can create</span>
				<h2 className={styles.h2} id="make-h">
					Turn your recommendations into <span className={styles.hl}>maps, guides and trips</span>
				</h2>
				<p className={styles.lede}>Add your favourite places once. Share them on your blog, in your bio and as trips your followers can copy.</p>
			</div>
			<div className={styles.blogfeat}>
				<div className={styles.bfCopy}>
					<span className={styles.pillPurple}>
						<Link fill="#7c3aed" /> For bloggers
					</span>
					<h3>Your blog post, now with a map that earns</h3>
					<p>
						Paste one embed code into any article. Readers explore your places right there, save the route to Stippl in a tap, and every reader who plans a trip
						earns you €0.50.
					</p>
					<ul className={styles.ticks2}>
						<li>
							<CheckCircle /> Works in any blog that takes an embed code: WordPress, Squarespace, Webflow
						</li>
						<li>
							<CheckCircle /> We link back to your article from our Discover page for that city
						</li>
						<li>
							<CheckCircle /> Readers who leave your page take your route with them, not just a screenshot
						</li>
					</ul>
					<div>
						<a className={`${styles.btn} ${styles.btnGreen}`} href="#apply">
							Get your embed map
						</a>
					</div>
				</div>
				<div className={styles.bfArt} aria-hidden="true">
					<div className={styles.post2}>
						<div className={styles.url}>
							<i></i>
							<i></i>
							<i></i>
							<span>yourblog.com/mexico-in-3-weeks</span>
						</div>
						<div className={styles.pbody}>
							<small className={styles.cat}>MEXICO · ITINERARY</small>
							<b className={styles.ttl}>3 weeks in Mexico (my route, stop by stop)</b>
							<div className={styles.by}>
								<span className={styles.a}>I</span>By Ilse · 8 min read
							</div>
							<p className={styles.tx}>
								I start in Mexico City with four slow days of tacos and museums, then head south to Oaxaca for the markets and the mezcal…
							</p>
							<div className={styles.semb}>
								<MexicoMap strokeWidth={3.4} />
								<div className={styles.sfoot}>
									<span className={styles.sfL}>
										<b>Mexico in 3 weeks</b>
										<small>by Ilse Jansen · 7 stops</small>
									</span>
									<span className={styles.sfB}>Save this route to Stippl</span>
								</div>
							</div>
						</div>
					</div>
					<span className={styles.earnpop}>
						+€0.50 <small>reader planned a trip</small>
					</span>
				</div>
			</div>
			<div className={styles.prods}>
				<div className={styles.prod}>
					<div className={`${styles.sc} ${styles.mkPhone}`}>
						<div className={styles.ph}>
							<img src={img("card-hotspot.webp")} alt="Hikes Madeira by Ilse Jansen as a map with places in the Stippl app" loading="lazy" />
						</div>
					</div>
					<div className={styles.bd}>
						<span className={styles.k}>Free</span>
						<b>A hotspot map</b>
						<p>All your places on one map that followers save in a tap. It's the easy yes that brings them in.</p>
					</div>
				</div>
				<div className={styles.prod}>
					<div className={`${styles.sc} ${styles.mkTrip2}`} aria-hidden="true">
						<div className={styles.tcard}>
							<MexicoMap strokeWidth={3} />
							<div className={styles.ssheet}>
								<div className={styles.shH}>
									<span className={styles.sav}>
										<img src={img("ilse-avatar.webp")} alt="" />
									</span>
									<span className={styles.t}>
										<b>Mexico in 3 weeks</b>
										<small>🇲🇽 Mexico · 23 days · 7 stops</small>
									</span>
								</div>
								<span className={styles.save2}>Make it my trip</span>
							</div>
						</div>
					</div>
					<div className={styles.bd}>
						<span className={styles.k}>Ready-made</span>
						<b>A trip to copy</b>
						<p>Your route as a Stippl trip. Followers make it theirs, change the dates and plan the rest around it.</p>
					</div>
				</div>
				<div className={styles.prod}>
					<div className={`${styles.sc} ${styles.mkPage}`} aria-hidden="true">
						<div className={styles.win}>
							<div className={styles.url}>
								<i></i>
								<i></i>
								<i></i>
								<span>stippl.io/c/ilseandreajansen</span>
							</div>
							<div className={`${styles.pg} ${styles.shot}`}>
								<img src={img("profile-shot.webp")} alt="Ilse's creator page on Stippl" />
							</div>
						</div>
					</div>
					<div className={styles.bd}>
						<span className={styles.k}>Yours</span>
						<b>Your own page</b>
						<p>
							stippl.io/c/yourname with your photo, your story and your links. The one link for your bio, and we promote it regularly to travellers across our
							network.
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
);

export default Make;
